export interface NextStep {
  title: string;
  values: string[];
}

const NextStepAccordion = ({ step }: { step: NextStep }) => {
  return (
    <div className="overflow-hidden rounded-lg border border-primaryGray-14">
      <div className="flex items-center justify-between px-4 py-3">
        <span className="text-h12 font-bold text-primaryGray-2">
          {step.title}
        </span>
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-primaryGray-16 px-2 py-0.5 text-x-tiny font-semibold text-primaryGray-3">
            {step.values.length}
          </span>
          {/* <ChevronDown rotate={180} stroke="#1F1F1F" /> */}
        </div>
      </div>
      <div className="flex flex-col gap-1 border-t border-primaryGray-14 bg-[#FAFBFC] px-4 py-3">
        {step.values.map((value, idx) => (
          <div
            key={idx}
            className="flex items-center gap-2 rounded-md px-2 py-1.5 text-small text-primaryGray-2 hover:bg-primaryGray-16"
          >
            <span className="h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primaryGray-8" />
            {value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NextStepAccordion;
